import { Helmet } from 'react-helmet-async'

/**
 * SEO Component — wraps react-helmet-async for per-page meta management.
 *
 * Usage:
 *   <SEO
 *     title="Portfolio | Jesse B Tattoos"
 *     description="Browse bold custom tattoo work by Jesse B."
 *     canonical="https://jessebtatoos.com/portfolio"
 *     ogImage="https://jessebtatoos.com/og-portfolio.jpg"
 *   />
 */
export default function SEO({
  title = 'Jesse B Tattoos | Bold Custom Tattoo Art',
  description = 'Jesse B Tattoos — bold, expressive, custom tattoo art. Book your session, explore the portfolio, and discover Tattoo Therapy services.',
  canonical,
  ogImage = 'https://jessebtatoos.com/og-image.jpg',
  noIndex = false,
}) {
  const siteUrl = 'https://jessebtatoos.com'
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Jesse B Tattoos" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  )
}
